var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center items-center"},[_c('span',{staticClass:"pr-2 text-12"},[_vm._v(_vm._s(_vm.label))]),_c('one-color-bar',{attrs:{"width":_vm.width,"innerText":_vm.innerText}}),_c('span',{staticClass:"pl-2 text-12"},[_vm._v(_vm._s(_vm.rightLabel))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }